import * as React from "react";
import { eventEmitter } from "./eventEmitter";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

export class ModalNotificationGlobal extends React.Component {
    state = {
        isVisible: false,
        title: "",
        message: "",
    };

    componentDidMount() {
        eventEmitter.on("showModalNotification", this.showNotification);
    }

    componentWillUnmount() {
        eventEmitter.off("showModalNotification", this.showNotification);
    }

    showNotification = (data: { title: string; message: string }) => {
        this.setState({
            isVisible: true,
            title: data.title,
            message: data.message,
        });
    };

    handleClose = () => {
        this.setState({ isVisible: false });
    };

    render() {
        const { isVisible, title, message } = this.state;

        if (!isVisible) {
            return null;
        }

        return (
            <Modal isOpen={isVisible} toggle={this.handleClose}>
               <ModalHeader toggle={this.handleClose}>{title}</ModalHeader>
                <ModalBody>
                    {message}
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={this.handleClose}>OK</Button>
                </ModalFooter>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/utils/modalNotificationGlobal.tsx